import ProfileHero from './ProfileHero';

export default ProfileHero;
